// không dùng path thuần tuý được sẽ báo lỗi
//bắt buộc dùng new URL
const worker = new Worker(new URL('./worker.ts', import.meta.url));
export default worker;